import { render, staticRenderFns } from "./RefundHistoriesPage.vue?vue&type=template&id=03c559d3&scoped=true"
import script from "./RefundHistoriesPage.vue?vue&type=script&lang=js"
export * from "./RefundHistoriesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c559d3",
  null
  
)

export default component.exports